import { API_BASE_URL } from "../config/api";

async function handleResponse(response) {
  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.detail || data?.message || "Erro na requisição.");
  }

  return data;
}

export async function getLegalDocuments() {
  const response = await fetch(`${API_BASE_URL}/legal/documents`);
  return handleResponse(response);
}

export async function getLegalDocumentBySlug(slug) {
  const response = await fetch(`${API_BASE_URL}/legal/document/${slug}`);
  return handleResponse(response);
}

export async function getPendingLegalAcceptances(userId) {
  const response = await fetch(`${API_BASE_URL}/legal/pending/${userId}`);
  return handleResponse(response);
}

export async function acceptLegalDocuments(payload) {
  const response = await fetch(`${API_BASE_URL}/legal/accept`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response);
}